function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import isEmpty from 'ramda/src/isEmpty';
import pathOr from 'ramda/src/pathOr';
import clone from 'ramda/src/clone';
import { ADJUSTMENT_CATEGORIES, ADJUSTMENT_PAYMENT_TYPES, BILL_ADJUSTMENT, DEPOSIT_ADJUSTMENT, MISC_ADJUSTMENT } from './adjustment.modal.constants';
import { i18n, AngularFormUtilities, BusinessUnitSelectors, MetadataActions, MetadataConstants, MetadataSelectors } from 'invision-core';
import { UserSecurityAttributesSelector } from 'invision-core/src/components/session/session.selectors';
import { hasAccess } from 'invision-core/src/components/security/permission.service';
import { createConvergentBillerAdjustment, retrieveInvoicesForDropdown } from '../../reducers/actions/customer.billing.actions';
import * as BillingPaymentsConstants from '../../components/billingPayments/billing.payments.constants';
import { AdjustmentConfigSelector, AdjustmentReasonCodeValueOptions, HierarchyInvoiceNodeSubscriberIdSelector, InvoiceListForDropDownSelector, InvoiceSummariesSelector, IsFetchingInvoiceListSelector } from './../../reducers/selectors/customer.billing.selectors';
import { IsCreatingConvergentBillerAdjustmentSelector } from '../../reducers/selectors/customer.convergent.biller.selectors';
import { CurrentCustomerSelector } from './../../reducers/selectors/customer.selectors';
import LocaleKeys from '../../locales/keys';
import moment from 'moment';
import { VIEW_INVOICE_DROPDOWN_ACCESS } from './../../security.attributes';
import { REPORTING_LEVELS } from '../../components/customer/accountHierarchy/account.hierarchy.constants';
var AdjustmentModalController = /*#__PURE__*/function () {
  function AdjustmentModalController($ngRedux, $timeout, $filter, uiNotificationService) {
    _classCallCheck(this, AdjustmentModalController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $timeout: $timeout,
      $filter: $filter,
      ADJUSTMENT_PAYMENT_TYPES: ADJUSTMENT_PAYMENT_TYPES,
      BILL_ADJUSTMENT: BILL_ADJUSTMENT,
      formattedInvoiceList: [],
      formattedInvoiceListforDebitAdjustments: [],
      getTitleByAdjustmentType: this.getTitleByAdjustmentType.bind(this),
      invoicesOptions: [],
      isStatement: this.isStatement.bind(this),
      REPORTING_LEVELS: REPORTING_LEVELS,
      resetFormValues: this.resetFormValues.bind(this),
      MISC_ADJUSTMENT: MISC_ADJUSTMENT,
      uiNotificationService: uiNotificationService
    });
  }
  return _createClass(AdjustmentModalController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          adjustmentConfig: AdjustmentConfigSelector(store),
          adjustmentReasonCodes: AdjustmentReasonCodeValueOptions(store),
          adjustmentReasonCodesLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.AdjustmentReason, store),
          currentBusinessUnitCurrencyCode: BusinessUnitSelectors.CurrentBusinessUnitCurrencyCodeSelector(store),
          currentCustomer: CurrentCustomerSelector(store),
          hierarchyInvoiceNodeSubscriberId: HierarchyInvoiceNodeSubscriberIdSelector(store),
          invoiceList: InvoiceListForDropDownSelector(store),
          invoiceSummaries: InvoiceSummariesSelector(store),
          isCreatingConvergentBillerAdjustment: IsCreatingConvergentBillerAdjustmentSelector(store),
          isFetchingInvoiceList: IsFetchingInvoiceListSelector(store),
          userSecurityAttributes: UserSecurityAttributesSelector(store)
        };
      };
      var controllerActions = {
        createAdjustment: createConvergentBillerAdjustment,
        fetchCodeType: MetadataActions.codes.fetchCodeTypes,
        retrieveInvoicesForDropdown: retrieveInvoicesForDropdown
      };
      this.localeKeys = LocaleKeys;
      this.adjustmentPaymentType = ADJUSTMENT_PAYMENT_TYPES.CREDIT;
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      if (!this.state.adjustmentReasonCodesLoaded) {
        this.actions.fetchCodeType(MetadataConstants.codes.AdjustmentReason);
      }
      this.getTitleByAdjustmentType(this.adjustmentType);
      if (this.state.invoiceSummaries.length) {
        this.currencyCode = this.state.invoiceSummaries[0].CurrencyCode;
      } else {
        this.currencyCode = this.state.currentBusinessUnitCurrencyCode;
      }
      this.MIN_ADJUSTMENT_AMOUNT = 0.01;
      this.MAX_DESCR_LENGTH = 200;
      this.minPostDate = new Date();
      this.selectedPostDate = new Date();
      this.selectedReasonCode = null;
      this.selectedInvoice = null;
      this.currentDate = new Date();
      if (this.adjustmentType === MISC_ADJUSTMENT && !this.referenceId) {
        this.hasInvoiceDropdownAccess = hasAccess(this.state.userSecurityAttributes, VIEW_INVOICE_DROPDOWN_ACCESS);
        if (this.hasInvoiceDropdownAccess) {
          this.getInvoiceList();
        }
      }
    }
  }, {
    key: "$onChanges",
    value: function $onChanges(changesObj) {
      if (changesObj) {
        if (changesObj.adjustmentType && changesObj.adjustmentType.currentValue !== changesObj.adjustmentType.previousValue) {
          this.getTitleByAdjustmentType(changesObj.adjustmentType.currentValue);
        }
        if (changesObj.referenceId && changesObj.referenceId.currentValue !== changesObj.referenceId.previousValue) {
          this.referenceId = changesObj.referenceId.currentValue;
        }
        if (changesObj.maxAdjustmentAmount && changesObj.maxAdjustmentAmount.currentValue !== changesObj.maxAdjustmentAmount.previousValue) {
          this.maxAdjustmentAmount = changesObj.maxAdjustmentAmount.currentValue;
        }
      }
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }, {
    key: "getTitleByAdjustmentType",
    value: function getTitleByAdjustmentType(adjustmentType) {
      if (adjustmentType === MISC_ADJUSTMENT) {
        this.titleText = i18n.translate(LocaleKeys.ADJUSTMENTS.APPLY_MISC_ADJUSTMENT);
        this.applyButtonText = i18n.translate(LocaleKeys.ADJUSTMENTS.APPLY_MISC_ADJUSTMENT);
        this.enableGenerateStatements = this.state && this.state.adjustmentConfig[BillingPaymentsConstants.ENABLE_GENERATE_STATEMENT] === BillingPaymentsConstants.ADJUSTMENT_CONFIG_ENABLED ? true : false;
      } else if (adjustmentType === BILL_ADJUSTMENT) {
        if (this.itemId) {
          this.enableGenerateStatements = this.state && this.state.adjustmentConfig[BillingPaymentsConstants.ENABLE_GENERATE_STATEMENT] === BillingPaymentsConstants.ADJUSTMENT_CONFIG_ENABLED ? true : false;
          this.titleText = i18n.translate(LocaleKeys.ADJUSTMENTS.APPLY_ITEM_ADJUSTMENT);
          this.applyButtonText = i18n.translate(LocaleKeys.ADJUSTMENTS.APPLY_ITEM_ADJUSTMENT);
        } else {
          this.titleText = i18n.translate(LocaleKeys.ADJUSTMENTS.APPLY_INVOICE_ADJUSTMENT);
          this.applyButtonText = i18n.translate(LocaleKeys.ADJUSTMENTS.APPLY_INVOICE_ADJUSTMENT);
        }
      } else if (adjustmentType === DEPOSIT_ADJUSTMENT) {
        this.titleText = i18n.translate(LocaleKeys.ADJUSTMENTS.APPLY_ADJUSTMENT);
        this.applyButtonText = i18n.translate(LocaleKeys.ADJUSTMENTS.APPLY_ADJUSTMENT);
      }
    }
  }, {
    key: "isStatement",
    value: function isStatement() {
      var _this$state$currentCu;
      return ((_this$state$currentCu = this.state.currentCustomer) === null || _this$state$currentCu === void 0 ? void 0 : _this$state$currentCu.HierarchyReportingLevel) === REPORTING_LEVELS.REPORTING_LEVEL_STATEMENT;
    }
  }, {
    key: "getInvoiceList",
    value: function getInvoiceList() {
      var _this2 = this;
      var getInvoiceListRequest = {
        customerId: this.state.currentCustomer.Id,
        request: {
          Filter: BillingPaymentsConstants.INVOICES
        }
      };
      this.actions.retrieveInvoicesForDropdown(getInvoiceListRequest).then(function () {
        _this2.formatInvoiceList();
        _this2.setInvoicesOptions();
      }).catch(function (error) {
        _this2.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      this.resetFormValues();
      this.onClose();
    }
  }, {
    key: "resetFormValues",
    value: function resetFormValues() {
      this.adjustmentAmount = undefined;
      this.selectedDescription = undefined;
      this.selectedReasonCode = undefined;
      this.adjustmentForm.$setUntouched();
      this.adjustmentForm.$setPristine();
    }
  }, {
    key: "adjustmentReasonCodes",
    get: function get() {
      var _this3 = this;
      var adjustmentReasonCodes = pathOr([], ['adjustmentReasonCodes'], this.state);
      return this.deviceFinanceHeading ? adjustmentReasonCodes.filter(function (reasonCode) {
        return reasonCode.adjustment_category === ADJUSTMENT_CATEGORIES.FINANCE && (_this3.adjustmentPaymentType === reasonCode.adjustment_payment_type || isEmpty(reasonCode.adjustment_payment_type));
      }) : adjustmentReasonCodes.filter(function (reasonCode) {
        return (reasonCode.adjustment_category === ADJUSTMENT_CATEGORIES.OTHER || isEmpty(reasonCode.adjustment_category)) && (_this3.adjustmentPaymentType === reasonCode.adjustment_payment_type || isEmpty(reasonCode.adjustment_payment_type));
      });
    }
  }, {
    key: "validMaxAdjustmentAmount",
    value: function validMaxAdjustmentAmount() {
      this.setInvoicesOptions();
      if (this.adjustmentType === MISC_ADJUSTMENT) {
        if (this.adjustmentPaymentType === ADJUSTMENT_PAYMENT_TYPES.DEBIT) {
          this.maxAdjustmentAmount = null;
        }
        if (this.adjustmentPaymentType === ADJUSTMENT_PAYMENT_TYPES.CREDIT) {
          var _this$selectedInvoice;
          this.maxAdjustmentAmount = this.selectedInvoice ? (_this$selectedInvoice = this.selectedInvoice) === null || _this$selectedInvoice === void 0 ? void 0 : _this$selectedInvoice.currentDue : null;
        }
      }
      return this.adjustmentPaymentType === ADJUSTMENT_PAYMENT_TYPES.CREDIT ? this.maxAdjustmentAmount || this.financeBalance : null;
    }
  }, {
    key: "validateForm",
    value: function validateForm() {
      var _this4 = this;
      this.$timeout(function () {
        _this4.formErrors = AngularFormUtilities.constraintErrorMessages(undefined, _this4.adjustmentForm, {
          accountNumber: LocaleKeys.ACCOUNT_NUMBER,
          adjustmentAmount: LocaleKeys.ADJUSTMENTS.ADJUSTMENT_AMOUNT,
          adjustmentDescription: LocaleKeys.ADJUSTMENTS.DESCRIPTIONS,
          reasonCode: LocaleKeys.ADJUSTMENTS.REASON_CODE
        }, {
          max: {
            adjustmentAmount: _this4.$filter('invCurrency')(_this4.maxAdjustmentAmount, _this4.currencyCode)
          },
          maxlength: {
            adjustmentDescription: _this4.MAX_DESCR_LENGTH
          },
          min: {
            adjustmentAmount: _this4.$filter('invCurrency')(_this4.MIN_ADJUSTMENT_AMOUNT, _this4.currencyCode)
          }
        });

        // AngularFormUtilities does not have support for three-field-date-input. This code hacks it in.
        _this4.formErrorMessages = _this4.formErrors.filter(function (error) {
          return error !== '';
        });
      });
    }
  }, {
    key: "setInvoicesOptions",
    value: function setInvoicesOptions() {
      this.invoicesOptions = this.adjustmentPaymentType === ADJUSTMENT_PAYMENT_TYPES.DEBIT ? this.formattedInvoiceListforDebitAdjustments : this.formattedInvoiceList;
    }
  }, {
    key: "save",
    value: function save() {
      var _this5 = this;
      if (this.adjustmentForm.$valid) {
        var isPostDateToday = moment().isSame(moment(this.selectedPostDate), 'day');
        var request = {
          customerId: this.state.currentCustomer.Id,
          request: {
            AccountNumber: this.accountNumber,
            AdjustmentPaymentType: this.adjustmentPaymentType,
            AdjustmentTypeCode: this.adjustmentType,
            Amount: parseFloat(this.adjustmentAmount).toFixed(2),
            Description: this.selectedDescription,
            EventId: this.itemId,
            GenerateStatement: this.enableGenerateStatements,
            InvoiceId: this.adjustmentType === MISC_ADJUSTMENT && this.selectedInvoice ? this.selectedInvoice.invoiceId : this.invoiceId,
            PostDate: isPostDateToday ? new Date() : this.selectedPostDate,
            ReasonCode: this.selectedReasonCode
          },
          BillingAndPayments: this.buildBillingAndPaymentsRequest()
        };
        this.actions.createAdjustment(request).then(function () {
          _this5.uiNotificationService.transientSuccess(i18n.translate(LocaleKeys.ADJUSTMENTS.ADJUSTMENT_SUCCESS));
          _this5.onSuccess();
          _this5.resetFormValues();
        }).catch(function (error) {
          _this5.formErrorMessages.push(error.translatedMessage);
          _this5.formErrors.push(error.translatedMessage);
        });
      } else {
        this.validateForm();
      }
    }
  }, {
    key: "buildBillingAndPaymentsRequest",
    value: function buildBillingAndPaymentsRequest() {
      return {
        customerId: this.state.currentCustomer.Id,
        request: {
          EndDate: this.state.billingAndPaymentsEndDate,
          Filter: BillingPaymentsConstants.ADJUSTMENTS | BillingPaymentsConstants.INVOICES | BillingPaymentsConstants.PAYMENTS,
          StartDate: this.state.billingAndPaymentsStartDate
        }
      };
    }
  }, {
    key: "formatInvoiceList",
    value: function formatInvoiceList() {
      var _this6 = this;
      function isFutureDatedInvoice(invoiceDueDate) {
        return invoiceDueDate && new Date(invoiceDueDate).getTime() > Date.now();
      }
      var clonedInvoiceSummaries = clone(this.state.invoiceList);
      clonedInvoiceSummaries.forEach(function (item) {
        if (item.Invoice.CurrentDue > 0) {
          _this6.formattedInvoiceList.push({
            currentDue: item.Invoice.CurrentDue,
            dueDate: item.Invoice.DueDate,
            invoiceId: item.Invoice.InvoiceId,
            text: "".concat(item.Invoice.InvoiceNumber, " - ").concat(_this6.$filter('invCurrency')(item.Invoice.CurrentDue, item.Invoice.CurrencyCode))
          });
        }
        if (item.Invoice.CurrentDue > 0 && isFutureDatedInvoice(item.Invoice.DueDate)) {
          _this6.formattedInvoiceListforDebitAdjustments.push({
            currentDue: item.Invoice.CurrentDue,
            dueDate: item.Invoice.DueDate,
            invoiceId: item.Invoice.InvoiceId,
            text: "".concat(item.Invoice.InvoiceNumber, " - ").concat(_this6.$filter('invCurrency')(item.Invoice.CurrentDue, item.Invoice.CurrencyCode), " - ").concat(_this6.$filter('localShortDate')(item.Invoice.DueDate))
          });
        }
      });
    }
  }]);
}();
export default {
  bindings: {
    adjustmentType: '<',
    config: '<',
    invoiceId: '<?',
    accountNumber: '<?',
    deviceFinanceHeading: '<?',
    financeBalance: '<?',
    itemId: '<?',
    itemText: '<?',
    isInvoiceAdjustment: '<?',
    maxAdjustmentAmount: '<?',
    onClose: '&',
    onSuccess: '&',
    referenceId: '<?',
    subscriberSummaryAccounts: '<?'
  },
  template: require('./adjustment.modal.html'),
  controller: AdjustmentModalController
};